"use client"

/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { FormControl, FormItem } from "components/ui/form";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "components/ui/select";
import { Controller } from "react-hook-form";
import { useGetJustificationActiveForDivergenceQuery } from "@/services/justification";

export default function SelectCellJustification({
  justification,
  rowId,
  control,
}: {
  justification?: number;
  rowId: string;
  control: any;
}) {
  const { data } = useGetJustificationActiveForDivergenceQuery();

  return (
    <Controller
      control={control}
      name={`divergence.justification_${rowId}`}
      defaultValue={justification ? justification.toString() : ""}
      render={({ field }) => (
        <FormItem>
          <Select onValueChange={field.onChange} value={field.value}>
            <FormControl className="!border !border-none w-full">
              <SelectTrigger
                // hasError={!!errors.divergence?.[`justification_${rowId}`]}
                className="text-gray-400"
              >
                <SelectValue placeholder="Selecione uma justificativa" />
              </SelectTrigger>
            </FormControl>
            <SelectContent className="z-[90]">
              {data?.map((item: any) => (
                <SelectItem key={item.id} value={item.id.toString()}>
                  {item.name}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
          {/* <FormMessage>
            {errors.divergence?.[`justification_${rowId}`]?.message}
          </FormMessage> */}
        </FormItem>
      )}
    />
  );
}
